// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__zepgL","topBottomGutter":"Layout_topBottomGutter__2inyr"};